import { NavLink, Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import '../css/nav.css';
import Logo from '../assets/sslg-elec.png';
import { useAuth } from '../../AuthContext';
import { useState } from 'react';
import LogoutConfirmation from '../popup/LogoutConfirmation';

const Nav = ({ menuOpen, toggleMenu }) => {
    const { logout, authorizedName } = useAuth();
    const navigate = useNavigate();
    const [showLogoutModal, setShowLogoutModal] = useState(false);

    const handleLogoutClick = () => {
        setShowLogoutModal(true);
    };

    const confirmLogout = () => {
        logout();
        toast.info('You have been successfully logged out.');
        navigate('/');
        setShowLogoutModal(false);
    };

    const cancelLogout = () => {
        setShowLogoutModal(false);
    };

    return (
        <>
            <nav className="nav-container">
                <Link to="/home">
                    <img src={Logo} alt="Logo" className="logo" style={{ height: '55px' }} />
                </Link>
                <div className={`nav-links ${menuOpen ? 'active' : ''}`}>
                    <ul>
                        <li><NavLink to="/home" onClick={toggleMenu}>Home</NavLink></li>
                        <li><NavLink to="/candidates" onClick={toggleMenu}>Candidates</NavLink></li>
                        <li><NavLink to="/electionform" onClick={toggleMenu}>ERF</NavLink></li>
                        <li><NavLink to="/electionresults" onClick={toggleMenu}>Results</NavLink></li>
                    </ul>
                    <div className="nav__btns">
                        {authorizedName && (
                            <div className="user-container">
                                <span className="logged-in-name">You're logged in as: <b>{authorizedName}</b></span>
                                <button className="btn sign__in" onClick={handleLogoutClick} style={{ textDecoration: 'none' }}>
                                    Logout
                                </button>
                            </div>
                        )}
                    </div>
                    <div className="social-icons mobile-social">
                        <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                            <i className="bx bxl-facebook"></i>
                        </a>
                        <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                            <i className="bx bxl-instagram"></i>
                        </a>
                        <a href="https://github.com" target="_blank" rel="noopener noreferrer">
                            <i className="bx bxl-github"></i>
                        </a>
                    </div>
                </div>
                <div className="menu-icon" onClick={toggleMenu}>
                    <i className='bx bx-menu'></i>
                </div>
            </nav>
            {showLogoutModal && (
                <LogoutConfirmation
                    onConfirm={confirmLogout}
                    onCancel={cancelLogout}
                />
            )}
        </>
    );
};


export default Nav;